module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.b9013782.svg";